import {
  Avatar, Card, Rate, Space, Typography
} from "antd";
import { useAppSelector } from "../../store";
import { currentDoctor } from "../../store/slices/user";

const { Title, Text } = Typography;

const CurrentDoctor = ({ doctorData }: { doctorData?: {
  photo: string;
  name: string;
  surname: string;
  policy_number: string;
  role: string;
  bio: string;
  feedbackAvg: number;
} }) => {
  const doctor = doctorData || useAppSelector(currentDoctor);

  return (
    <Card style={{ overflow: "auto" }}>
      {doctor
        ? (
          <Space size={16} direction="vertical">
            {doctor.photo
              ? <Avatar size={121} src={<img src={doctor.photo} alt="avatar" />} />
              : null}
            {doctor.feedbackAvg !== undefined ? <Rate
              disabled
              value={doctor.feedbackAvg}
              style={{
              fontSize: 14,
              color: "#54C8C1",
              position: "absolute",
              top: 24,
              right: 16,
            }}
            /> : null}
            <Title level={4} style={{ marginBottom: 0 }}>
              {`Dott. ${doctor.name} ${doctor.surname}`}
            </Title>
            {doctor.policy_number ? <span>n. polizza {doctor.policy_number}</span> : null}
            <Text type="secondary" style={{ fontSize: 18, lineHeight: "1.2" }}>
              {doctor.role === "oncologist"
                ? "Psicologo Specializzato in Supporto Oncologico"
                : null}
              {doctor.role === "nutrizionist"
                ? "Nutrizionista Specializzato in Supporto Oncologico"
                : null}
            </Text>
            {doctor.bio ? (
              <Text type="secondary" style={{ fontSize: 16, lineHeight: "1.2" }}>
                {doctor.bio}
              </Text>
            ) : null}
          </Space>
        )
        : "There is no doctor"}
    </Card>
  );
};

export default CurrentDoctor;
